import React, { Component } from "react"
import classes from "./hamburger.module.scss"

class Hamburger extends Component {
  constructor(props) {
    super(props)

    this.state = {
      HamburgerOpen: false,
    }
  }
  handleClick = () => {
    this.setState({ HamburgerOpen: !this.state.HamburgerOpen })
    this.props.menuOpen()
  }
  render() {
    return (
      <div className={classes.Start} onClick={this.handleClick}>
        <div className={classes.Middle} />
      </div>
    )
  }
}

export default Hamburger
